import { useRef, useState } from "react";

// Draggable floating button: position persists in localStorage; a tap without
// movement fires onTap. Returns { style, onPointerDown } to spread on the button.
export function useDraggable(storageKey, defaultPos, onTap) {
  const [pos, setPos] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || "null");
      if (saved && saved.x >= 0 && saved.x < window.innerWidth - 24 && saved.y >= 0 && saved.y < window.innerHeight - 24) return saved;
    } catch { /* ignore */ }
    return typeof defaultPos === "function" ? defaultPos() : defaultPos;
  });
  const tapRef = useRef(onTap);
  tapRef.current = onTap;

  const clamp = (x, y) => ({ x: Math.min(Math.max(4, x), window.innerWidth - 52), y: Math.min(Math.max(4, y), window.innerHeight - 52) });

  const onPointerDown = (e) => {
    e.preventDefault();
    const startX = e.clientX, startY = e.clientY;
    const orig = { ...pos };
    let moved = false;
    const onMove = (ev) => {
      const dx = ev.clientX - startX, dy = ev.clientY - startY;
      if (!moved && Math.abs(dx) + Math.abs(dy) > 6) moved = true;
      if (moved) setPos(clamp(orig.x + dx, orig.y + dy));
    };
    const onUp = (ev) => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
      if (moved) {
        localStorage.setItem(storageKey, JSON.stringify(clamp(orig.x + (ev.clientX - startX), orig.y + (ev.clientY - startY))));
      } else {
        tapRef.current?.();
      }
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  return { pos, style: { left: pos.x, top: pos.y, right: "auto", bottom: "auto", touchAction: "none", cursor: "grab" }, onPointerDown };
}
